var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUfo = function SvgUfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.75 20.25 3.932-6.348M20.25 20.25l-3.932-6.348M7.765 7.084a3.82 3.82 0 0 1-.015-.334c0-2.21 1.903-4 4.25-4s4.25 1.79 4.25 4c0 .113-.005.224-.015.334m-8.47 0C4.217 7.674 1.75 8.982 1.75 10.5c0 1.507 2.429 2.806 5.932 3.402m.083-6.818A26.036 26.036 0 0 1 12 6.75c1.51 0 2.944.12 4.235.334m0 0c3.548.59 6.015 1.898 6.015 3.416 0 1.507-2.429 2.806-5.932 3.402m-8.636 0 1.805-2.913c.288-.465.752-.802 1.295-.87a9.546 9.546 0 0 1 2.436 0c.543.068 1.007.405 1.295.87l1.805 2.913"
  })));
};
export default SvgUfo;